import React from 'react';
export function Footer() {
  return <footer className="w-full bg-navy-950 px-5 pb-28 pt-12 text-center text-slate-400" data-id="element-133" data-mp="32wd2qgad7ltj">
      <div className="mx-auto max-w-3xl" data-id="element-134" data-mp="3gg0xpz2xhpvj">
        <p className="font-display text-2xl font-extrabold uppercase text-white" data-id="element-135" data-mp="32nulgo2wc31d">
          TCM Diagnostic <span className="text-electric-400" data-id="element-136" data-mp="36pft9v0kpr4p">Blueprint™</span>
        </p>
        <p className="mt-2 text-[14px]" data-id="element-137" data-mp="36ppjnjpj60ax">
          A practical visual decision system for automotive electronics technicians working with Transmission Control
          Modules. Created by Jason Mitchell.
        </p>
        <p className="mt-6 text-[12px] leading-relaxed" data-id="element-138" data-mp="36d1st00yll7">
          Educational reference material only. This product does not replace manufacturer service information,
          professional training, appropriate technical equipment, or required hands-on experience. Always follow
          applicable manufacturer procedures, technical specifications, safety requirements, and local laws. Diagnostic
          findings must be verified for the specific vehicle, transmission, and TCM being serviced.
        </p>
        <p className="mt-6 text-[12px]" data-id="element-139" data-mp="3gah29wtj3p7f">© 2026 · Jason Mitchell · TCM Diagnostic Blueprint™ · All Rights Reserved.</p>
      </div>
    </footer>;
}